import React from 'react';

const FAQ = () => {
  const faqs = [
    {
      question: "How do I book a wildlife safari?",
      answer: "You can book a safari by visiting our Wildlife Sanctuaries page, selecting the sanctuary you wish to visit, and clicking the 'Book Safari' button. You can also contact our support team directly via the Contact page."
    },
    {
      question: "Are your trekking expeditions safe for beginners?",
      answer: "Yes! We offer treks across all difficulty levels. Each trek on our Trekking page has a difficulty rating (Easy, Moderate, Hard). We recommend beginners start with 'Easy' treks like the Kheerganga Trek. Our expert guides ensure safety at all times."
    },
    {
      question: "What is the best time to visit national parks in India?",
      answer: "The best time to visit most national parks in India is between October and May. During the summer months (April to May), animals frequent waterholes, making sightings easier. Most parks are closed during the monsoon season (July to September)."
    },
    {
      question: "Do you provide trekking equipment?",
      answer: "Yes, we provide essential group equipment including tents, sleeping bags, sleeping mats, and cooking gear. Personal items like trekking shoes, clothing, and backpacks need to be brought by the participants."
    },
    {
      question: "What is your cancellation policy?",
      answer: "Cancellations made 30 days prior to the departure date will receive a full refund minus a small processing fee. Cancellations made within 15-29 days receive a 50% refund. Cancellations made less than 15 days prior are non-refundable."
    }
  ];

  return (
    <div className="container section">
      <div style={{ maxWidth: '800px', margin: '0 auto', backgroundColor: '#fff', padding: '3rem', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.05)' }}>
        <h1 className="section-title" style={{ marginBottom: '2.5rem', textAlign: 'left' }}>Frequently Asked Questions</h1>
        
        <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
          {faqs.map((faq, index) => (
            <div key={index} style={{ borderBottom: index === faqs.length - 1 ? 'none' : '1px solid #e5e7eb', paddingBottom: index === faqs.length - 1 ? '0' : '1.5rem' }}>
              <h3 style={{ fontSize: '1.2rem', color: '#111', marginBottom: '0.8rem', fontWeight: 'bold' }}>
                {faq.question}
              </h3>
              <p style={{ color: '#4b5563', lineHeight: '1.6', margin: 0 }}>
                {faq.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
